import { supabase } from './supabase';

type RpcResult<T>={data:T|null;error:{message:string}|null};
export type JobPhaseAttachment={id:string;file_name:string;mime_type:string|null;size_bytes:number|null;storage_bucket:string;storage_path:string;created_at:string};
export type JobPhaseDocument={job_id:string;phase_id:string;phase_code:string;phase_type:string;sequence_no:number;instructions:string|null;attachments:JobPhaseAttachment[]};
export type JobPhaseDocuments={contract_version:string;storage_bucket:string;phases:JobPhaseDocument[]};

async function rpc<T>(name:string,args:Record<string,unknown>):Promise<RpcResult<T>>{const r=await supabase.rpc(name,args);return{data:(r.data??null) as T|null,error:r.error?{message:r.error.message}:null};}
function safeName(name:string){return name.replace(/[^a-zA-Z0-9._-]+/g,'_').slice(-120)||'attachment';}

export const jobPhaseDocumentsApi={
  forJobs:(jobIds:string[])=>rpc<JobPhaseDocuments>('get_job_phase_documents',{p_job_ids:jobIds}),
  saveInstructions:(phaseId:string,instructions:string)=>rpc<string>('set_job_phase_instructions',{p_phase_id:phaseId,p_instructions:instructions}),
  async uploadAttachment(organizationId:string,jobId:string,phaseId:string,file:File):Promise<RpcResult<string>>{
    if(file.size>20*1024*1024)return{data:null,error:{message:'Attachment exceeds the 20 MB limit.'}};
    const bucket='job-phase-attachments';
    const path=`${organizationId}/${jobId}/${phaseId}/${Date.now()}-${crypto.randomUUID()}-${safeName(file.name)}`;
    const up=await supabase.storage.from(bucket).upload(path,file,{contentType:file.type||'application/octet-stream',upsert:false});
    if(up.error)return{data:null,error:{message:up.error.message}};
    const reg=await rpc<string>('register_job_phase_attachment',{p_phase_id:phaseId,p_storage_path:path,p_file_name:file.name,p_mime_type:file.type||null,p_size_bytes:file.size});
    if(reg.error)await supabase.storage.from(bucket).remove([path]);
    return reg;
  },
  async removeAttachment(attachment:JobPhaseAttachment):Promise<RpcResult<string>>{
    const r=await rpc<string>('delete_job_phase_attachment',{p_attachment_id:attachment.id});
    if(r.error)return r;
    const path=r.data||attachment.storage_path;
    const removed=await supabase.storage.from(attachment.storage_bucket).remove([path]);
    if(removed.error)return{data:path,error:{message:`Attachment record removed, but stored file cleanup failed: ${removed.error.message}`}};
    return{data:path,error:null};
  },
  async openAttachment(attachment:JobPhaseAttachment):Promise<RpcResult<string>>{
    const r=await supabase.storage.from(attachment.storage_bucket).createSignedUrl(attachment.storage_path,3600);
    return{data:r.data?.signedUrl??null,error:r.error?{message:r.error.message}:null};
  }
};
